import { useState } from 'react'

type UseControls = {
  isOpen: boolean

  open: () => void
  close: () => void
  toggle: () => void
}

const useControls = (): UseControls => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)

  const close = () => setIsOpen(false)

  const toggle = () => setIsOpen(!isOpen)

  return {
    isOpen,
    open,
    close,
    toggle,
  }
}

export default useControls
